import { DialogContentText } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import LinearProgress from '@mui/material/LinearProgress'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  contentText: string
  confirmButtonText?: string
  confirmButtonIcon?: JSX.Element
  onCancel: () => void
  onConfirm: () => Promise<void>
  isPending: boolean
  showDialog: boolean
  confirmIsDangerous?: boolean
}

export type ConfirmDialogInputProps = {
  title: string
  contentText: string
  onConfirm: () => Promise<void>
  confirmIsDangerous: boolean
}

export default function ConfirmDialog({
  title,
  contentText,
  confirmButtonText,
  confirmButtonIcon,
  onCancel,
  onConfirm,
  isPending,
  showDialog,
  confirmIsDangerous,
}: Props): JSX.Element {
  const { t } = useTranslation()

  return (
    <>
      {showDialog ? (
        <Dialog open={!!showDialog} maxWidth="sm" fullWidth>
          {isPending && <LinearProgress />}
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{contentText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={isPending} onClick={onCancel}>
              {t('cancel')}
            </Button>
            <Button
              variant="contained"
              disabled={isPending}
              onClick={onConfirm}
              color={confirmIsDangerous ? 'error' : 'primary'}
              startIcon={confirmButtonIcon ? confirmButtonIcon : undefined}
            >
              {confirmButtonText ? confirmButtonText : t('confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <></>
      )}
    </>
  )
}
